import {
  ADD_CUSTOMER_FAIL,
  ADD_CUSTOMER_REQUEST,
  ADD_CUSTOMER_SUCCESS,
  DELETE_CUSTOMER_FAIL,
  DELETE_CUSTOMER_REQUEST,
  DELETE_CUSTOMER_SUCCESS,
  GET_CUSTOMER_LIST,
  GET_CUSTOMER_LIST_FAIL,
  GET_CUSTOMER_LIST_SUCCESS,
  GET_SINGLE_CUSTOMER,
  GET_SINGLE_CUSTOMER_FAIL,
  GET_SINGLE_CUSTOMER_SUCCESS,
  UPDATE_CUSTOMER_FAIL,
  UPDATE_CUSTOMER_REQUEST,
  UPDATE_CUSTOMER_SUCCESS,
} from "src/constants/types";

export const customerReducer = (state = {}, actions) => {
  switch (actions.type) {
    case GET_CUSTOMER_LIST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_CUSTOMER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        customers: actions.payload,
        error: "",
      };
    case GET_CUSTOMER_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case DELETE_CUSTOMER_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case DELETE_CUSTOMER_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_CUSTOMER_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case ADD_CUSTOMER_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_SINGLE_CUSTOMER:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        selected_customer: actions.payload,
      };
    case GET_SINGLE_CUSTOMER_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case UPDATE_CUSTOMER_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case UPDATE_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_CUSTOMER_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
